import type React from 'react';

interface ImageIconProps {
	width?: number;
	height?: number;
}

const ImageIcon: React.FC<ImageIconProps> = ({ width = 44, height = 45 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 44 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Image file icon"
		>
			<path
				d="M34.344 0.112793L43.0958 9.23583V43.9285H10.4023V44.0418H43.2075V9.35065L34.344 0.112793Z"
				fill="#909090"
			/>
			<path
				d="M34.2378 0H10.293V43.929H43.0981V9.23786L34.2378 0Z"
				fill="#F4F4F4"
			/>
			<path
				d="M10.0511 2.35938H0V13.0978H31.616V2.35938H10.0511Z"
				fill="#7A7B7C"
			/>
			<path
				d="M31.783 12.9153H0.203125V2.16895H31.783V12.9153Z"
				fill="#9C27B0"
			/>
			<path d="M8 5V11H24V5H8ZM9.5 6.5H22.5V9.5H9.5V6.5Z" fill="white" />
			<path
				d="M11 7.5C11 7.77614 10.7761 8 10.5 8C10.2239 8 10 7.77614 10 7.5C10 7.22386 10.2239 7 10.5 7C10.7761 7 11 7.22386 11 7.5Z"
				fill="white"
			/>
			<path d="M15 18H38V38L30 30L25 35L20 30L15 35V18Z" fill="#CE93D8" />
			<path
				d="M21 22C21 23.1046 20.1046 24 19 24C17.8954 24 17 23.1046 17 22C17 20.8954 17.8954 20 19 20C20.1046 20 21 20.8954 21 22Z"
				fill="#FFD54F"
			/>
			<path
				d="M34.1172 0.121582V9.35944H42.9775L34.1172 0.121582Z"
				fill="#909090"
			/>
			<path d="M34.2344 0V9.23786H43.0947L34.2344 0Z" fill="#F4F4F4" />
		</svg>
	);
};

export default ImageIcon;
